import { render, staticRenderFns } from "./InformationTabBrands.vue?vue&type=template&id=9d136d4a&scoped=true"
import script from "./InformationTabBrands.vue?vue&type=script&lang=ts"
export * from "./InformationTabBrands.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d136d4a",
  null
  
)

export default component.exports